export default __webpack_public_path__ + "static/media/mk logo finD.988c0c6f.png";